import type {LayoutPayload} from '@github-ui/code-view-types'
import {getQueryClient} from '@github-ui/react-core/query-client'
import {useParams} from '@github-ui/react-router'
import type {RefInfo} from '@github-ui/repos-types'
import {useEffect} from 'react'

import {codeViewLayoutRoute} from '../routes/code-view-layout-route'

export function useUpdateRefInfoAndPath(refInfo: RefInfo, path: string) {
  const {owner, repo} = useParams()

  useEffect(() => {
    const queryClient = getQueryClient()
    const layoutQueryKey = codeViewLayoutRoute.queries.mainQuery.makeQueryKey({
      pathname: `/${owner}/${repo}/_layout`,
    })
    const layoutData = queryClient.getQueryData<{payload: LayoutPayload}>(layoutQueryKey)

    if (!layoutData) return

    queryClient.setQueryData(layoutQueryKey, (oldData: {payload: LayoutPayload} | undefined) => {
      if (!oldData) return oldData

      return {
        ...oldData,
        payload: {
          ...oldData.payload,
          refInfo: {
            ...oldData.payload.refInfo,
            ...refInfo,
          },
          path,
        },
      }
    })
  }, [refInfo, path, owner, repo])
}
